import {useLoaderData, useSearchParams} from "react-router-dom";
import {getAllRecipes, searchRecipesByNameAndIngredient} from "../../services/RecipeService";
import {useContext, useEffect, useState} from "react";
import DisplayContext from "../../context/DisplayContext";
import Search from "../../components/input/search/Search";
import styles from './SearchResults.module.css'
import RecipeList from "../../components/recipe-list/RecipeList";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const SearchResults = () => {
  const [page, setPage] = useState(0)
  const [recipesPage, setRecipesPage] = useState(useLoaderData())
  const [searchParams, setSearchParams] = useSearchParams()
  const searchQuery = searchParams.get('q')
  const [query, setQuery] = useState(searchQuery)
  const {toggleHeaderSearch} = useContext(DisplayContext)

  useEffect(() => {
    document.title = `Search results for: ${searchQuery}`
    toggleHeaderSearch(false)
  }, [toggleHeaderSearch, searchQuery])
  useEffect(() => {
    (async () => {
      setRecipesPage(await searchRecipesByNameAndIngredient(query, 0))
    })()
  }, [query]);
  useEffect(() => {
    (async () => {
      setRecipesPage(await searchRecipesByNameAndIngredient(searchQuery, page))
    })()
  }, [page]);

  const search = () => setSearchParams(() => ({'q': query}))

  return (
    <div id={styles['search-results-wrapper']}>
      <Search id={styles['body-search-bar']} defaultValue={query} onChange={setQuery} action={search}>
        <FontAwesomeIcon icon={["far", "magnifying-glass"]} color="black"/>
      </Search>
      <br/>
      <em>Search results for: {searchQuery}</em>
      <RecipeList recipes={recipesPage} id={styles['search-results']} setPage={ setPage }/>
    </div>
  )
}


const searchResultsLoader = ({request}) => {
  const query = new URL(request.url).searchParams.get("q");
  return searchRecipesByNameAndIngredient(query)
}

export default SearchResults
export {searchResultsLoader}
